import { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const getColumns = (onEdit: (row: any) => void): ColumnDef<any>[] => [
  {
    accessorKey: "collection_profiles",
    header: "Name",
    cell: ({ row }) => {
      const profiles = row.getValue("collection_profiles") as any[];
      return (
        <div className="font-medium">
          {profiles?.[0]?.name || "Unnamed Collection"}
        </div>
      );
    },
  },
  {
    accessorKey: "product_containers",
    header: "Products",
    cell: ({ row }) => {
      const containers = row.getValue("product_containers") as any[];
      return containers?.length || 0;
    },
    meta: { width: "100px" },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              onClick={() => {
                console.log(row.original);
                onEdit(row.original);
              }}
            >
              Edit Collection
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
    meta: { width: "60px" },
  },
];
